module.exports = __webpack_public_path__ + "static/media/illustartion-wind-turbine.0a82721b.svg";